/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFPopularityRankingResult } from './CRSFPopularityRankingResult';
import {
    CRSFPopularityRankingResultFromJSON,
    CRSFPopularityRankingResultFromJSONTyped,
    CRSFPopularityRankingResultToJSON,
} from './CRSFPopularityRankingResult';
import type { CRSFPrivacyCriticalTrackingTech } from './CRSFPrivacyCriticalTrackingTech';
import {
    CRSFPrivacyCriticalTrackingTechFromJSON,
    CRSFPrivacyCriticalTrackingTechFromJSONTyped,
    CRSFPrivacyCriticalTrackingTechToJSON,
} from './CRSFPrivacyCriticalTrackingTech';
import type { CRSFPrivacyInfoResult } from './CRSFPrivacyInfoResult';
import {
    CRSFPrivacyInfoResultFromJSON,
    CRSFPrivacyInfoResultFromJSONTyped,
    CRSFPrivacyInfoResultToJSON,
} from './CRSFPrivacyInfoResult';
import type { CRSFPrivacyPolicyAnalysisExternalResult } from './CRSFPrivacyPolicyAnalysisExternalResult';
import {
    CRSFPrivacyPolicyAnalysisExternalResultFromJSON,
    CRSFPrivacyPolicyAnalysisExternalResultFromJSONTyped,
    CRSFPrivacyPolicyAnalysisExternalResultToJSON,
} from './CRSFPrivacyPolicyAnalysisExternalResult';
import type { CRSFPrivacySpecificTrackingTechEnum } from './CRSFPrivacySpecificTrackingTechEnum';
import {
    CRSFPrivacySpecificTrackingTechEnumFromJSON,
    CRSFPrivacySpecificTrackingTechEnumFromJSONTyped,
    CRSFPrivacySpecificTrackingTechEnumToJSON,
} from './CRSFPrivacySpecificTrackingTechEnum';
import type { CRSFPrivacyStatusEnum } from './CRSFPrivacyStatusEnum';
import {
    CRSFPrivacyStatusEnumFromJSON,
    CRSFPrivacyStatusEnumFromJSONTyped,
    CRSFPrivacyStatusEnumToJSON,
} from './CRSFPrivacyStatusEnum';
import type { CRSFPrivacyTechnologiesResult } from './CRSFPrivacyTechnologiesResult';
import {
    CRSFPrivacyTechnologiesResultFromJSON,
    CRSFPrivacyTechnologiesResultFromJSONTyped,
    CRSFPrivacyTechnologiesResultToJSON,
} from './CRSFPrivacyTechnologiesResult';

/**
 * 
 * @export
 * @interface CRSFPrivacyData
 */
export interface CRSFPrivacyData {
    /**
     * 
     * @type {Array<CRSFPrivacyCriticalTrackingTech>}
     * @memberof CRSFPrivacyData
     */
    critical_tracking_techs?: Array<CRSFPrivacyCriticalTrackingTech>;
    /**
     * 
     * @type {CRSFPopularityRankingResult}
     * @memberof CRSFPrivacyData
     */
    popularity_ranking?: CRSFPopularityRankingResult;
    /**
     * 
     * @type {CRSFPrivacyInfoResult}
     * @memberof CRSFPrivacyData
     */
    privacy_info?: CRSFPrivacyInfoResult;
    /**
     * 
     * @type {CRSFPrivacyPolicyAnalysisExternalResult}
     * @memberof CRSFPrivacyData
     */
    privacy_policy_analysis?: CRSFPrivacyPolicyAnalysisExternalResult;
    /**
     * 
     * @type {CRSFPrivacyStatusEnum}
     * @memberof CRSFPrivacyData
     */
    status?: CRSFPrivacyStatusEnum;
    /**
     * 
     * @type {CRSFPrivacyTechnologiesResult}
     * @memberof CRSFPrivacyData
     */
    technologies_found?: CRSFPrivacyTechnologiesResult;
    /**
     * 
     * @type {Array<CRSFPrivacySpecificTrackingTechEnum>}
     * @memberof CRSFPrivacyData
     */
    undeclared_tracking_technology?: Array<CRSFPrivacySpecificTrackingTechEnum>;
}

/**
 * Check if a given object implements the CRSFPrivacyData interface.
 */
export function instanceOfCRSFPrivacyData(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CRSFPrivacyDataFromJSON(json: any): CRSFPrivacyData {
    return CRSFPrivacyDataFromJSONTyped(json, false);
}

export function CRSFPrivacyDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFPrivacyData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'critical_tracking_techs': !exists(json, 'critical_tracking_techs') ? undefined : ((json['critical_tracking_techs'] as Array<any>).map(CRSFPrivacyCriticalTrackingTechFromJSON)),
        'popularity_ranking': !exists(json, 'popularity_ranking') ? undefined : CRSFPopularityRankingResultFromJSON(json['popularity_ranking']),
        'privacy_info': !exists(json, 'privacy_info') ? undefined : CRSFPrivacyInfoResultFromJSON(json['privacy_info']),
        'privacy_policy_analysis': !exists(json, 'privacy_policy_analysis') ? undefined : CRSFPrivacyPolicyAnalysisExternalResultFromJSON(json['privacy_policy_analysis']),
        'status': !exists(json, 'status') ? undefined : CRSFPrivacyStatusEnumFromJSON(json['status']),
        'technologies_found': !exists(json, 'technologies_found') ? undefined : CRSFPrivacyTechnologiesResultFromJSON(json['technologies_found']),
        'undeclared_tracking_technology': !exists(json, 'undeclared_tracking_technology') ? undefined : ((json['undeclared_tracking_technology'] as Array<any>).map(CRSFPrivacySpecificTrackingTechEnumFromJSON)),
    };
}

export function CRSFPrivacyDataToJSON(value?: CRSFPrivacyData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'critical_tracking_techs': value.critical_tracking_techs === undefined ? undefined : ((value.critical_tracking_techs as Array<any>).map(CRSFPrivacyCriticalTrackingTechToJSON)),
        'popularity_ranking': CRSFPopularityRankingResultToJSON(value.popularity_ranking),
        'privacy_info': CRSFPrivacyInfoResultToJSON(value.privacy_info),
        'privacy_policy_analysis': CRSFPrivacyPolicyAnalysisExternalResultToJSON(value.privacy_policy_analysis),
        'status': CRSFPrivacyStatusEnumToJSON(value.status),
        'technologies_found': CRSFPrivacyTechnologiesResultToJSON(value.technologies_found),
        'undeclared_tracking_technology': value.undeclared_tracking_technology === undefined ? undefined : ((value.undeclared_tracking_technology as Array<any>).map(CRSFPrivacySpecificTrackingTechEnumToJSON)),
    };
}

